import {zDateTime, zNumberToString} from '@brunata-angular/util';
import {z} from 'zod';

const meterDataSchema = z.object({
    meterId: zNumberToString,
    locationMeterId: zNumberToString,
    placement: z.string().nullable(),
    meterNo: z.string(),
    printedSerialNo: z.string().nullable(),
    meterType: z.number(),
    scale: z.number().nullable(),
    unitFactor: z.number().nullable(),
    mountingDate: zDateTime.nullable(),
    dismountedDate: zDateTime.nullable(),
    transmitting: z.boolean(),
    allocationUnit: z.string(),
    unit: z.string(),
    meterSequenceNo: z.number(),
    model: z.string().nullable(),
    radioTechnology: z.string().nullable().optionalUntilDeployed('AGI-20301'),
    realInstallationDate: zDateTime.nullable(),
    geoLocation: z.object({
        latitude: z.number().nullable(),
        longitude: z.number().nullable(),
    }),
    unitReduction: z.number().nullable(),
    meterConnectionType: z.string().nullable(),
    shutoffValve: z.string().nullable(),
    meterSize: z.string().nullable(),
    meterBuildLength: z.number().nullable(),
    dinRail: z.boolean().nullable(),
    maxCurrent: z.number().nullable(),
    sensorPocket: z.boolean().nullable(),
    supplyOrReturnFlow: z.string().nullable(),
    primaryChannel: z.boolean().nullable(),
    address: z.string().nullable(),
    meterSuperTypeNo: z.number().nullable(),
    systemName: z.string().nullable(),
    propertyNo: z.string().nullable(),
    branchNo: z.string().nullable(),
    locationNo: z.string().nullable(),
});

export const meterDataMasterSchema = meterDataSchema.extend({
    slaves: z.array(meterDataSchema).optional(),
});

export type MeterData = z.infer<typeof meterDataMasterSchema>;
